export default {
    chartTypes: [
        {
            text: 'Quarterly Revenue',
            value: 'revenue',
        },
        {
            text: 'Growth Rate',
            value: 'growth',
        },
        {
            text: 'New Drugs',
            value: 'new',
        },
    ],
    cumulativeTypes: [
        {
            text: 'Cumulative by Brand',
            value: 'none',
        },
        {
            text: 'Cumulative by Company',
            value: 'company',
        },
        {
            text: 'Cumulative by Category',
            value: 'category',
        },
        {
            text: 'Cumulative by Sub Category',
            value: 'sub-category',
        },
        {
            text: 'Cumulative by Class',
            value: 'class',
        },

    ],
    growthRates: [
        {
            text: 'More than 30%',
            value: '30_',
        },
        {
            text: 'Between 10% and 30%',
            value: '10_30',
        },
        {
            text: 'Between -10% and 10%',
            value: '-10_10',
        },
        {
            text: 'Between -30% and -10%',
            value: '-30_-10',
        },
        {
            text: 'Less than -30%',
            value: '_-30',
        },
    ],
    growthRatesQuarters: [
        {
            text: 'At least 1 quarter connected',
            value: '1',
        },
        {
            text: 'At least 2 quarters connected',
            value: '2',
        },
        {
            text: 'At least 3 quarters connected',
            value: '3',
        },
        {
            text: 'At least 4 quarters connected',
            value: '4',
        },
        {
            text: 'At least 5 quarters connected',
            value: '5',
        },
    ],
    maxRange: 5,
    minYear: 2010,
};
